import { FeatureAppIntegrator } from './feature-apps/feature-app-integrator';
import {
  processFeatureServices,
  setupIntegrator,
} from './feature-hub/feature-hub-integrator';
import { displayPreviewTenant } from './internal/display-preview-tenant';
import {
  applyPreEosImageHandshake,
  requiresEosImageHandshake,
} from './internal/pre-eos-image-author-preview';
import { createLogger } from './create-logger';

const PAGE_LOADED = 'PAGE_LOADED';
const LAYER_LOADED = 'LAYER_LOADED';
const CONTENT_RENDERED = 'content:rendered';

export const applyFeatureHub = async (
  event: CustomEvent,
  featureAppIntegrator: FeatureAppIntegrator,
): Promise<void> => {
  if (
    event &&
    event.type &&
    (event.type === PAGE_LOADED ||
      event.type === LAYER_LOADED ||
      event.type === CONTENT_RENDERED)
  ) {
    if (event.detail && event.detail.element) {
      await featureAppIntegrator.initFeatureApps(event.detail.element);
    }
  }
};

export const integrateFeatureApps = async (): Promise<void> => {
  const { contentStore, featureAppManager, featureServices } =
    setupIntegrator();

  processFeatureServices(featureServices);

  const featureAppIntegrator = new FeatureAppIntegrator(
    featureAppManager,
    featureServices,
    contentStore,
  );

  const applyFeatureHubToPartial = (event: CustomEvent): void => {
    applyFeatureHub(event, featureAppIntegrator);
  };

  document.addEventListener(PAGE_LOADED, applyFeatureHubToPartial);
  document.addEventListener(LAYER_LOADED, applyFeatureHubToPartial);
  document.addEventListener(CONTENT_RENDERED, applyFeatureHubToPartial);

  setTimeout(async () => {
    if (requiresEosImageHandshake(document.head)) {
      const logger = createLogger();
      await applyPreEosImageHandshake(document.head, logger);
    }
    displayPreviewTenant(
      featureServices['notification-display-service'],
      document.head,
    );

    await featureAppIntegrator.initFeatureApps(document.body);
  });
};

export { type FeatureServiceConfigOverride } from './feature-hub/service-definitions';
